import { Button, CircularProgress, TextField } from "@mui/material";
import axios from "../../../utils/axiosInstance";
import { enqueueSnackbar } from "notistack";
import React, { Ref, createRef, useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CreatePagePopup from "./createPagePopup";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import ContentCurationCard from "./ContentCurationCard";
import DeleteModal from "../../UI/atoms/Popup/DeleteModal";
import { RAIL_TYPE } from "../../../constants/configuration.const";
import { useLocation, useNavigate } from "react-router";
import {
    COLLECTIONS,
    CW_CAROUSEL,
    DRAFT_STATUS,
    EPISODIC_RAIL,
    GENRE,
    HERO_CAROUSEL,
    HERO_RAIL,
    HORIZONTAL_RAIL,
    LIVE,
    MY_LIST,
    NO_RESULTS,
    OTHER_RAIL,
    PAGE_NAME_MISSING,
    PAGE_TEMPLATE,
    POPULAR_SEARCH,
    POPULAR_SEARCHES,
    POSTER_HORIZONTAL,
    POSTER_VERTICAL,
    SINGULAR_PROMO,
    THEMATIC,
} from "../LandingPage/constants";
import { Field, Form, Formik, FormikValues } from "formik";
import * as yup from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TimePicker } from "@mui/x-date-pickers";
import GeneralModal from "../../UI/atoms/Popup/GeneralModal";
import {
    MILLIS_TO_LOCALE_DATE_TIME_FORMAT_POPUP,
    mergeDateTime,
} from "../../../utilities/helpers/formatUnix";
import GeneralModalV1 from "../../UI/atoms/Popup/GeneralModalV1";
import HeroContentCurationCard from "./HeroContentCurationCard";
import GenreContentCurationCard from "./GenreContentCurationCard";
import { sortArrayObject } from "../../../utilities/helpers/helperfunctions";
import moment from "moment-timezone";
import ThematicContentCurationCard from "./ThematicContentCurationCard";
import SingularPromoContentCurationCard from "./SingularPromoContentCurationCard";
import EpisodicContentCurationCard from "./EpisodicContentCurationCard";
import CollectionsContentCurationCard from "./CollectionsContentCurationCard";
import {
    ACTION,
    PERMISSIONS,
    usePermissions,
} from "../../../utils/permissions";

dayjs.extend(utc);
dayjs.extend(timezone);

const ContentCurationList = () => {
    const timezoneCode = moment.tz(moment.tz.guess()).zoneAbbr();

    // set initial values
    const initialValues: FormikValues = {
        versionName: "",
        template: "",
        publishDate: dayjs(new Date()),
        publishTime: null,
        genres: [],
    };

    const [formValues, setFormValues] = useState(initialValues);
    const [openCreatePopup, setOpenCreatePopup] = useState(false);
    const [railList, setRailList] = useState<any>([]);
    const [heroRail, setHeroRails] = useState<any>([]);
    const [otherRails, setOtherRails] = useState<any>([]);
    const [cwRail, setCWRails] = useState<any>([]);
    const [selectedIndex, setSelectedIndex] = useState<any>(null);
    const [isPageDeleteModalOpen, setIsPageDeleteModalOpen] = useState(false);
    const [isPagePublishModalOpen, setIsPagePublishModalOpen] = useState(false);
    const [isPageSuccessModalOpen, setIsPageSuccessModalOpen] = useState(false);
    const [publishStatus, setPublishStatus] = useState("");
    const [publishArn, setPublishArn] = useState("");

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [publishLoader, setPublishLoader] = useState(false);
    const [errorMessagePublish, setErrorMessagePublish] = useState("");
    const [playlist, setPlaylist] = useState<any>([]);
    const [heroCarousalBanners, setHeroCarousalBanners] = useState<any>(null); // Handles all the banners from the HeroCarousal
    const [isHeroBannerValid, setIsHeroBannerValid] = useState(true);
    const [heroBannersInDraft, setHeroBannersInDraft] = useState<any>(null);
    const [showHeroBanners, setShowHeroBanners] = useState(false);

    const [videos, setVideos] = useState<any>([]);
    const [videoAPILoader, setVideoAPILoader] = useState(false);
    const [genreMasterList, setGenreMasterList] = useState<any[]>([]);
    const [defaultTime, setDefaultTime] = useState<any>(dayjs(new Date()));
    const [allowEdit, setAllowEdit] = useState<any>(false);
    const [cwUnlockPopup, setCwUnlockPopup] = useState(false);

    const navigate = useNavigate();

    // hooks
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const pageName = queryParams.get("pageName");
    const form = useRef<any>(null);
    const heroCarousalRef = useRef<any>(null);
    const railRefs = useRef<any[]>([]);

    const [hideAddButton, setHideAddButton] = useState(false);
    const { hasPermission } = usePermissions();

    useEffect(() => {
        if (formValues?.template === POPULAR_SEARCH && otherRails.length > 2) {
            setHideAddButton(true);
        } else if (formValues?.template === POPULAR_SEARCH) {
            setHideAddButton(false);
        }
    }, [otherRails]);

    const openDeleteModal = () => {
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const setAndResetDefault = () => {
        setDefaultTime(null);
    };

    useEffect(() => {
        getPlayListAPI(); // get all playlist
        getVideosAPI(); // get all videos
        getRailListing(); // get all rail items
        getGenreAPI();
    }, []);

    useEffect(() => {
        if (
            hasPermission(PERMISSIONS.curation, ACTION.EDIT) &&
            publishStatus &&
            publishStatus == DRAFT_STATUS
        ) {
            setAllowEdit(true);
        }
    }, [publishStatus]);

    const getGenreAPI = async () => {
        try {
            const saveVersion = await axios.get(
                `${process.env.BASE_URL}api/v1/cms/genre`
            );
            setGenreMasterList(
                sortArrayObject(saveVersion.data?.data?.list, "genreTitle")
            );
            return saveVersion.data?.data;
        } catch (error: any) {
            console.log("Error in getting master information", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        const heroContent = heroCarouselListing(railList);
        setHeroRails(heroContent);
        const cwContent = cwCarouselListing(railList);
        setCWRails(cwContent);
        const otherRailContent = restCarouselListing(railList);
        setOtherRailCall(otherRailContent);
    }, [railList]);

    const setOtherRailCall = (values: any[]) => {
        // setOtherRailRefs(() => [Array.from({ length: value.length }, () => createRef())]);
        railRefs.current = [];
        values.map((val: any) => {
            railRefs.current.push(React.createRef());
        });
        setOtherRails(values);
    };

    const setHeroBanners = (value: any) => {
        const heroRailsState = [...heroRail];
        heroRailsState[0].banners = value.banners;
        setHeroCarousalBanners(value);
        setHeroRails(heroRailsState);
    };

    const getPlayListAPI = async () => {
        try {
            const materInformation = await axios.get(
                `${process.env.BASE_URL}api/v1/cms/playlist/fetch`
            );
            if (materInformation.data?.success) {
                setPlaylist(materInformation.data?.data);
            } else {
                enqueueSnackbar(materInformation.data?.message, {
                    variant: "error",
                });
            }
        } catch (error) {
            console.log("Error in getting master information", error);
        }
    };

    const getVideosAPI = async () => {
        try {
            setVideoAPILoader(true);
            const videoInfo = await axios.get(
                `${process.env.BASE_URL}api/v2/cms/videos/all`
            );
            if (videoInfo.data?.success) {
                setVideos(videoInfo.data?.data);
            } else {
                enqueueSnackbar(videoInfo.data?.message, { variant: "error" });
            }
        } catch (error) {
            console.log("Error in getting master information", error);
        } finally {
            setVideoAPILoader(false);
        }
    };

    // Update rail list to add the banner in the hero carousal
    const updateRailListWithHeroBanner = (
        railList: any,
        banners = heroCarousalBanners?.banners
    ) => {
        // if no rails, return the array
        let resultRailList = [...railList]; // making deep copy
        if (resultRailList.length == 0) return resultRailList;
        if (resultRailList[0].template == HERO_CAROUSEL)
            resultRailList[0].banners = banners || [];
        return resultRailList;
    };

    const reorderRails = (otherRailsValue = otherRails) => {
        // Order rails inthe order hero,cw, rest of the rails.
        const rails = [...heroRail, ...cwRail, ...otherRailsValue];
        return rails;
    };

    // saving the array of page rails in DB
    const onClickSaveButton = async () => {
        try {
            if (!allowEdit) return; // secondary check for restricting user if allowEdit is false
            const validatedOtherRails = validateRailForms();
            if (!validatedOtherRails) return;
            let bannerValues;
            if (railList.length == 0) {
                enqueueSnackbar("No Rails Found", { variant: "warning" });
                return;
            }

            //Save Hero Banner
            if (heroRail.length) {
                bannerValues = saveHeroCarousalBanner();
                if (!bannerValues) return;
            }

            setLoader(true);
            let { values, isValid } = form.current;
            values = updatePublishDate(values);
            if (isValid) {
                // Update the banners before making the API call
                const orderedRail = reorderRails(validatedOtherRails);
                const updatedRails = updateRailListWithHeroBanner(
                    orderedRail,
                    bannerValues
                );
                let payload = {
                    items: updatedRails,
                    versionName: values.versionName,
                    publishDate: values.publishDate || null,
                    publishTime: values.publishTime || null,
                };
                payload = updatePublishTime(payload);
                console.log(payload);
                const saveRail = await axios.post(
                    `${process.env.BASE_URL}api/v1/cms/page?pageName=${pageName}`,
                    payload
                );
                if (saveRail?.data?.success) {
                    enqueueSnackbar(saveRail?.data?.message, {
                        variant: "success",
                    });
                    navigate("/content-curation-versions");
                } else {
                    enqueueSnackbar(saveRail?.data?.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(PAGE_NAME_MISSING, { variant: "warning" });
            }
        } catch (error: any) {
            console.log(error);
            enqueueSnackbar(error?.response?.data?.message, {
                variant: "error",
            });
            console.log("Error in getting master information", error);
        } finally {
            setLoader(false);
            setErrorMessagePublish("");
        }
    };

    const validateRailForms = () => {
        try {
            let index = 0;
            let invalidRail = 0;
            let otherRailsValue = [...otherRails];
            for (const rail of otherRails) {
                if (
                    rail.template == THEMATIC ||
                    rail.template == SINGULAR_PROMO ||
                    rail.template == GENRE ||
                    rail.template == EPISODIC_RAIL ||
                    rail.template == COLLECTIONS
                ) {
                    console.log(railRefs.current[index]);
                    let formValue;
                    try {
                        const isValid =
                            railRefs.current[index].current.isValid();
                        if (isValid == null) {
                            // if it is null, the form has not been opened yet
                            otherRailsValue[index] = rail;
                        } else if (isValid) {
                            formValue =
                                railRefs.current[index].current.getFormValue();
                            otherRailsValue[index] = {
                                ...otherRailsValue[index],
                                ...formValue,
                            };
                            // railRefs.current[index].current.handleSubmit()
                        } else {
                            railRefs.current[index].current.handleSubmit();
                            invalidRail++;
                        }
                    } catch (error: any) {
                        if (error.message == "NO_ACTIONS") {
                            invalidRail++;
                        } else {
                            otherRailsValue[index] = {
                                ...otherRailsValue[index],
                                ...formValue,
                            };
                        }
                    }
                } else {
                    otherRailsValue[index] = rail;
                }
                index++;
            }
            console.log(otherRailsValue);
            return (invalidRail == 0 && otherRailsValue) || null;
        } catch (error) {
            console.log("error in validateRailForms");
            return null;
        }
    };

    // keeping publshTime in sync with publishDate
    const updatePublishTime = (values: any) => {
        const { publishDate, publishTime } = values;
        if (publishDate && publishTime) {
            const ptime = new Date(publishTime);
            const pdate = new Date(publishDate);
            ptime.setDate(pdate.getDate());
            ptime.setMonth(pdate.getMonth());
            ptime.setFullYear(pdate.getFullYear());
            values.publishTime = ptime;
            values.publishDate = ptime;
        }
        return values;
    };

    const saveHeroCarousalBanner = () => {
        let bannerValues;
        const isBannerValid = heroCarousalRef?.current?.isValid();
        if (showHeroBanners) {
            if (isBannerValid) {
                bannerValues = heroCarousalRef.current.getFormValues().banners;
            } else {
                invalidBannerTrigger();
                return null;
            }
        } else if (!isBannerValid) {
            invalidBannerTrigger();
        } else {
            if (!heroBannersInDraft) {
                bannerValues = heroRail[0]?.banners || [];
            } else if (isHeroBannerValid) {
                bannerValues = heroBannersInDraft || [];
            } else if (!isHeroBannerValid) {
                invalidBannerTrigger();
                return null;
            } else if (heroCarousalBanners) {
                bannerValues = heroCarousalBanners?.banners;
            } else {
                invalidBannerTrigger();
                return null;
            }
        }
        return bannerValues;
    };

    const invalidBannerTrigger = () => {
        heroCarousalRef?.current?.onOpenBanner();
        setTimeout(() => {
            heroCarousalRef?.current?.submitHeroBanner();
        }, 500);
        enqueueSnackbar("Invalid hero banners found", { variant: "warning" });
    };

    // closing rail popup
    const handleClosePopup = () => {
        setOpenCreatePopup(false);
        setSelectedIndex(null);
    };

    // open the popup
    const handleOpenPopup = (index: number = 0) => {
        setOpenCreatePopup(true);
        setSelectedIndex({ index: index + 1 });
    };

    // handle add rail
    const handleAddRail = (payload: any) => {
        setOpenCreatePopup(false);
        const rail = [...railList];
        rail.splice(selectedIndex.index || 0, 0, payload);
        setRailList([...rail]);
        setSelectedIndex(null);
    };

    // first entry
    const heroCarouselListing = (payload: any[]) => {
        const heroEntry = payload.filter(
            (rail) => rail.template == HERO_CAROUSEL
        );
        if (heroEntry.length) {
            // AFTER GETTING THE RAIL LISTING FROM API. MAKE SURE TO SET THE HERO BANNERS TO AVOID,DIRECT SAVE
            const banners = heroEntry[0].banners;
            setHeroCarousalBanners({ banners });
        }
        return heroEntry;
    };

    const cwCarouselListing = (payload: any[]) => {
        const cwEntry = payload.filter(
            (rail) => rail.template == CW_CAROUSEL && !rail.unlock
        );
        return cwEntry;
    };

    // rest of the entries
    const restCarouselListing = (payload: any[]) => {
        const restEntry = payload.filter(
            (rail) =>
                !(
                    rail.template == HERO_CAROUSEL ||
                    (rail.template == CW_CAROUSEL && !rail.unlock)
                )
        );
        return restEntry;
    };

    // delete popup
    const handleDeleteRail = (
        index: number,
        type: string,
        unlock: any = null
    ) => {
        setSelectedIndex({ index, type, unlock });
        setIsDeleteModalOpen(true);
    };

    // on click of edit
    const handleEditRail = (payload: any, index: number, type: string) => {
        if (!allowEdit) return; // secondary check for restricting user if allowEdit is false
        setSelectedIndex({ index, type, payload });
        setOpenCreatePopup(true);
    };

    // on click of edit submission
    const handleEditSubmission = (
        payload: any,
        index: number,
        type: string
    ) => {
        let rails = [];
        if (type === RAIL_TYPE.hero) {
            setHeroRails([payload]);
            rails = [payload, ...otherRails];
        } else if (type === RAIL_TYPE.continue_watching && !payload.unlock) {
            setCWRails([payload]);
            rails = [...heroRail, payload, ...otherRails];
        } else if (type === RAIL_TYPE.continue_watching && payload.unlock) {
            const otherRailInfo = [...otherRails];
            otherRailInfo[index] = payload;
            rails = [...heroRail, ...otherRailInfo];
        } else {
            const otherRailInfo = [...otherRails];
            otherRailInfo[index] = payload;
            // setOtherRailCall([...otherRailInfo])
            rails = [...heroRail, ...cwRail, ...otherRailInfo];
        }
        setRailList([...rails]);
        setOpenCreatePopup(false);
        setSelectedIndex(null);
    };

    const deleteTheObject = () => {
        let rails = [];
        if (selectedIndex.type === RAIL_TYPE.hero) {
            rails = [...cwRail, ...otherRails];
            setHeroRails([]);
        } else if (
            selectedIndex.type === RAIL_TYPE.continue_watching &&
            !selectedIndex.unlock
        ) {
            rails = [...heroRail, ...otherRails];
            setCWRails([]);
        } else {
            const otherRailInfo = otherRails.filter(
                (rail: any, index: number) => index !== selectedIndex.index
            );
            // setOtherRailCall([...otherRailInfo])
            rails = [...heroRail, ...cwRail, ...otherRailInfo];
        }
        setRailList([...rails]);
        setIsDeleteModalOpen(false);
        setSelectedIndex(null);
    };

    // call API for getting the master information
    const getRailListing = async () => {
        try {
            const materInformation = await axios.get(
                `${process.env.BASE_URL}api/v1/cms/page?pageName=${pageName}`
            );
            setAndResetDefault();
            if (materInformation.data?.success) {
                setPublishArn(materInformation.data?.data?.publishArn);
                updateFormValues(materInformation.data?.data);
                setPublishStatus(materInformation.data?.data?.publishStatus);
                setRailList(materInformation.data?.data?.items || []);
            } else {
                enqueueSnackbar(materInformation.data?.message, {
                    variant: "error",
                });
            }
        } catch (error) {
            console.log("Error in getting master information", error);
        }
    };

    const openPageDeleteModal = (page: any) => {
        setIsPageDeleteModalOpen(true);
    };

    const closePageDeleteModal = () => {
        setIsPageDeleteModalOpen(false);
    };

    const openPagePublishModal = () => {
        setIsPagePublishModalOpen(true);
    };

    const closePagePublishModal = () => {
        setIsPagePublishModalOpen(false);
    };

    const openPageSuccessModal = () => {
        setIsPageSuccessModalOpen(true);
    };

    const closePageSuccessModal = () => {
        setIsPageSuccessModalOpen(false);
    };

    // call API for getting the master information
    const deleteRailPage = async () => {
        if (!allowEdit) return; // secondary check for restricting user if allowEdit is false
        try {
            const materInformation = await axios.delete(
                `${
                    process.env.BASE_URL
                }api/v1/cms/page/${pageName}?status=${publishStatus}&eventArn=${
                    publishArn || ""
                }`
            );
            if (materInformation.data?.success) {
                enqueueSnackbar(materInformation.data?.message, {
                    variant: "success",
                });
                navigate("/content-curation-versions");
            } else {
                enqueueSnackbar(materInformation.data?.message, {
                    variant: "error",
                });
            }
        } catch (error) {
            console.log("Error in getting master information", error);
        }
    };

    // event for drag end
    const onDragEnd = (result: any) => {
        try {
            // dropped outside the list
            if (!result.destination) {
                return;
            }
            if (
                result?.destination?.droppableId ===
                    result?.source?.droppableId &&
                result?.destination?.index === result?.source?.index
            ) {
                return;
            }
            const items = reorder(
                otherRails,
                result.source.index,
                result.destination.index
            );

            // setOtherRailCall(items)

            // update the original list
            setRailList([...heroRail, ...cwRail, ...items]);
        } catch (error) {
            console.log("Error when drag end", error);
        }
    };

    const grid = 4;

    const getItemStyle = (isDragging: any, draggableStyle: any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,
        // styles we need to apply on draggables
        ...draggableStyle,
    });

    const getListStyle = (isDraggingOver: any) => ({
        padding: grid,
        width: "100%",
    });

    const reorder = (list: any, startIndex: any, endIndex: any) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    // validation schema
    const validationSchema = yup.object({
        versionName: yup.string().required("Name is required"),
    });

    const updateFormValues = (value: any) => {
        setFormValues({
            versionName: value.versionName,
            canonicalName: value.canonicalName,
            template: value.template,
            publishDate: value.publishDate || null,
            publishTime: value.publishTime || null,
        });
    };

    const updatePublishDate = (formValue: any) => {
        if (formValue?.publishDate && formValue?.publishTime) {
            formValue.publishDate = mergeDateTime(
                formValue?.publishDate,
                formValue?.publishTime
            );
            return formValue;
        }
        return formValue;
    };

    const publishPage = async () => {
        try {
            if (!allowEdit) return; // secondary check for restricting user if allowEdit is false
            let bannerValues;
            const validatedOtherRails = validateRailForms();
            if (!validatedOtherRails) return;

            if (railList.length == 0) {
                enqueueSnackbar("No Rails Found", { variant: "warning" });
                return;
            }

            //Save Hero Banner
            if (heroRail.length) {
                bannerValues = saveHeroCarousalBanner();
                if (!bannerValues) return;
            }
            setErrorMessagePublish("");
            setPublishLoader(true);
            let { values, isValid } = form.current;
            if (isValid) {
                const orderedRail = reorderRails(validatedOtherRails);
                const updatedRails = updateRailListWithHeroBanner(
                    orderedRail,
                    bannerValues
                );
                values = updatePublishDate(values);
                let payload = {
                    items: updatedRails,
                    versionName: values.versionName,
                    publishDate: values.publishDate,
                    publishTime: values.publishTime,
                };
                payload = updatePublishTime(payload);
                const publishRail = await axios.post(
                    `${process.env.BASE_URL}api/v1/cms/page/publish?pageName=${pageName}`,
                    payload
                );
                if (publishRail?.data?.success) {
                    openPageSuccessModal();
                    // SHOW SUCCESS POPUP
                } else {
                    enqueueSnackbar(publishRail?.data?.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(PAGE_NAME_MISSING, { variant: "warning" });
            }
        } catch (error: any) {
            setErrorMessagePublish(error?.response?.data?.message);
            console.log("Error in getting master information", error);
            closePagePublishModal();
        } finally {
            setPublishLoader(false);
        }
    };

    const validatePage = async () => {
        try {
            if (!allowEdit) return; // secondary check for restricting user if allowEdit is false
            let bannerValues;

            if (railList.length == 0) {
                enqueueSnackbar("No Rails Found", { variant: "warning" });
                return;
            }

            //Save Hero Banner
            if (heroRail.length) {
                bannerValues = saveHeroCarousalBanner();
                if (!bannerValues) return;
            }
            setErrorMessagePublish("");
            setPublishLoader(true);
            let { values, isValid } = form.current;
            values = updatePublishDate(values);
            if (isValid) {
                const publishRail = await axios.post(
                    `${process.env.BASE_URL}api/v1/cms/page/validate`,
                    {
                        items: railList,
                        versionName: values.versionName,
                        publishDate: values.publishDate,
                        publishTime: values.publishTime,
                    }
                );
                if (publishRail?.data?.success) {
                    openPagePublishModal();
                } else {
                    enqueueSnackbar(publishRail?.data?.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(PAGE_NAME_MISSING, { variant: "warning" });
            }
        } catch (error: any) {
            setErrorMessagePublish(error?.response?.data?.message);
            console.log("Error in getting master information", error);
            closePagePublishModal();
        } finally {
            setPublishLoader(false);
        }
    };

    const successPage = () => {
        navigate("/content-curation-versions");
    };

    const setTime = (date: any) => {
        const dateTime = new Date();
        dateTime.setHours(date?.$H);
        dateTime.setMinutes(date?.$m);
        return dateTime;
    };

    // on click of Save genre, update the rail title with the same
    const updateValue = (value: any, index: number, fieldName: string) => {
        const actualIndex = heroRail.length + cwRail.length + index;
        let rail = [...heroRail, ...cwRail, ...otherRails];
        rail[actualIndex][fieldName] = value[fieldName] || [];
        setRailList([...rail]);
    };

    // for updateing genre rail title
    const saveRailTitle = (value: any, index: number) => {
        const actualIndex = heroRail.length + cwRail.length + index;
        let rail = [...railList];
        rail[actualIndex].railTitle = value || "";
        setRailList([...rail]);
    };

    const onBeforeCapture = (beforeCapture: any) => {
        // Check if the draggable being captured is a child
        if (beforeCapture.draggableId.startsWith("genres-")) {
            // Prevent capturing the parent by returning null
            return null;
        }
        return beforeCapture;
    };

    // on click of Save genre, update the rail title with the same
    const setRailData = (value: any, index: number) => {
        const actualIndex = heroRail.length + cwRail.length + index;
        let rail = [...heroRail, ...cwRail, ...otherRails];
        rail[actualIndex] = { ...rail[actualIndex], ...value };
        setRailList([...rail]);
    };

    const onThematicFormChange = (formInfo: any, index: number) => {
        let railInfo = [...otherRails];
        railInfo[index] = { ...railInfo[index], ...formInfo };
        setOtherRails(railInfo);
    };

    const handleCWUnlock = () => {
        // Adding a flag to indicate is the CW rail is unlocked
        const otherRailList = [{ ...cwRail[0], unlock: true }, ...otherRails];
        let rail = [...heroRail, ...otherRailList];
        setRailList([...rail]);
        setCwUnlockPopup(false);
    };

    return (
        <div className="config-heading w-65">
            {/* Delete Rail */}
            <DeleteModal
                title="Delete Rail?"
                isOpen={isDeleteModalOpen}
                handleClose={closeDeleteModal}
                handleConfirm={deleteTheObject}
            >
                <p>Are you sure you want to delete the rail?</p>
            </DeleteModal>

            {/* Delete Page */}
            <DeleteModal
                title="Delete Page?"
                isOpen={isPageDeleteModalOpen}
                handleClose={closePageDeleteModal}
                handleConfirm={deleteRailPage}
            >
                <p>
                    Are you sure you want to delete {formValues?.versionName}?
                </p>
            </DeleteModal>

            {isPageSuccessModalOpen && (
                <GeneralModalV1
                    title="Success"
                    hideCancelButton={true}
                    confirmMessage={"Done"}
                    isOpen={isPageSuccessModalOpen}
                    handleClose={closePageSuccessModal}
                    handleConfirm={successPage}
                >
                    <p>
                        '{form.current?.values?.versionName}' is scheduled to go
                        live on{" "}
                        {MILLIS_TO_LOCALE_DATE_TIME_FORMAT_POPUP(
                            updatePublishTime({
                                publishDate: form.current?.values.publishDate,
                                publishTime: form.current?.values.publishTime,
                            }).publishTime
                        )}{" "}
                        {dayjs(form.current?.values.publishTime).format(
                            "hh:mm A"
                        )}{" "}
                        {timezoneCode}
                    </p>
                </GeneralModalV1>
            )}

            <div className="d-flex">
                <Formik
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    innerRef={form}
                    onSubmit={() => console.log("submitted")}
                    enableReinitialize
                >
                    {({
                        values,
                        handleChange,
                        touched,
                        errors,
                        setFieldValue,
                    }: any) => (
                        <Form className="w-100">
                            {isPagePublishModalOpen && (
                                <GeneralModalV1
                                    title="Confirm Publish Date"
                                    isOpen={isPagePublishModalOpen}
                                    handleClose={closePagePublishModal}
                                    handleConfirm={publishPage}
                                >
                                    <p>
                                        Schedule '{values.versionName}' on{" "}
                                        {MILLIS_TO_LOCALE_DATE_TIME_FORMAT_POPUP(
                                            updatePublishTime({
                                                publishDate: values.publishDate,
                                                publishTime: values.publishTime,
                                            }).publishTime
                                        )}{" "}
                                        {dayjs(values.publishTime).format(
                                            "hh:mm A"
                                        )}{" "}
                                        {timezoneCode}?
                                    </p>
                                </GeneralModalV1>
                            )}

                            <div className="d-flex j-space">
                                <Field
                                    name="versionName"
                                    as={TextField}
                                    className="w-250p"
                                    label="Page Name"
                                    value={values.versionName}
                                    onChange={handleChange}
                                    error={
                                        touched.versionName &&
                                        errors.versionName
                                    }
                                    helperText={
                                        values.canonicalName &&
                                        values.canonicalName
                                    }
                                    disabled={!allowEdit}
                                />

                                <Field
                                    name="template"
                                    as={TextField}
                                    label="Template"
                                    value={PAGE_TEMPLATE[values.template]}
                                    onChange={handleChange}
                                    disabled={true}
                                    error={touched.template && errors.template}
                                    helperText={
                                        touched.template && errors.template
                                    }
                                    InputLabelProps={{ shrink: true }}
                                />
                            </div>
                            <div className="mt-2">
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <div className="d-flex flex-column">
                                        {railList && (
                                            <DatePicker
                                                label="Publish Date"
                                                className="w-250p"
                                                format="MMM DD,YYYY"
                                                defaultValue={defaultTime}
                                                value={
                                                    (values.publishDate &&
                                                        (values.publishTime
                                                            ? dayjs(
                                                                  updatePublishTime(
                                                                      {
                                                                          publishDate:
                                                                              values.publishDate,
                                                                          publishTime:
                                                                              values.publishTime,
                                                                      }
                                                                  ).publishTime
                                                              )
                                                            : dayjs(
                                                                  values.publishDate
                                                              ))) ||
                                                    null
                                                }
                                                onChange={(e: any) => {
                                                    console.log(e);
                                                    setFieldValue(
                                                        "publishDate",
                                                        e.$d
                                                    );
                                                }}
                                                sx={
                                                    defaultTime && {
                                                        input: {
                                                            color: "text.primary",
                                                        }, // Uses theme color
                                                        "& .MuiOutlinedInput-root":
                                                            {
                                                                "& fieldset": {
                                                                    borderColor:
                                                                        "rgba(255, 255, 255, 0.23)", // Subtle border
                                                                },
                                                            },
                                                    }
                                                }
                                                disabled={!allowEdit}
                                                openTo="day"
                                                views={["year", "month", "day"]}
                                            />
                                        )}

                                        <div className="mt-2 d-flex j-space">
                                            <TimePicker
                                                closeOnSelect={false}
                                                label="Publish Time"
                                                className="w-250p"
                                                format={
                                                    "hh:mm a " + timezoneCode
                                                }
                                                defaultValue={defaultTime}
                                                value={
                                                    (values.publishTime &&
                                                        dayjs(
                                                            values.publishTime
                                                        )) ||
                                                    null
                                                }
                                                onChange={(e: any) => {
                                                    setFieldValue(
                                                        "publishTime",
                                                        setTime(e)
                                                    );
                                                }}
                                                sx={
                                                    defaultTime && {
                                                        input: {
                                                            color: "text.primary",
                                                        }, // Uses theme color
                                                        "& .MuiOutlinedInput-root":
                                                            {
                                                                "& fieldset": {
                                                                    borderColor:
                                                                        "rgba(255, 255, 255, 0.23)", // Subtle border
                                                                },
                                                            },
                                                    }
                                                }
                                                disabled={!allowEdit}
                                            />
                                            <div className="d-flex j-end">
                                                {allowEdit && (
                                                    <>
                                                        <Button
                                                            onClick={
                                                                openPageDeleteModal
                                                            }
                                                            className="float-right mt-1 mr-1"
                                                            color="error"
                                                            variant="contained"
                                                        >
                                                            Delete Page
                                                        </Button>
                                                        <Button
                                                            disabled={loader}
                                                            onClick={
                                                                onClickSaveButton
                                                            }
                                                            className="float-right mt-1"
                                                            variant="contained"
                                                        >
                                                            {loader && (
                                                                <CircularProgress
                                                                    size="1rem"
                                                                    style={{
                                                                        color: "inherit",
                                                                        marginRight: 5,
                                                                    }}
                                                                />
                                                            )}{" "}
                                                            Save
                                                        </Button>

                                                        <Button
                                                            className="float-right mt-1 ml-1"
                                                            disabled={
                                                                publishLoader
                                                            }
                                                            onClick={
                                                                validatePage
                                                            }
                                                            variant="contained"
                                                        >
                                                            {publishLoader && (
                                                                <CircularProgress
                                                                    size="1rem"
                                                                    style={{
                                                                        color: "white",
                                                                        marginRight: 5,
                                                                    }}
                                                                />
                                                            )}{" "}
                                                            Publish
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </LocalizationProvider>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>

            {errorMessagePublish && (
                <span className="float-right text-danger publish-error-text">
                    {errorMessagePublish}
                </span>
            )}

            <div className="curation-list-container mt-1">
                {/* Show + button only when no rails are there in list */}
                {railList.length == 0 && (
                    <div className="d-flex j-center m-2">
                        <span onClick={() => handleOpenPopup()}>
                            <AddCircleOutlineIcon />
                        </span>
                    </div>
                )}
                {/* Hero rail */}
                {heroRail.map((rail: any, index: number) => {
                    return (
                        <div key={index} className="d-flex j-center mt-1">
                            {/* hero carousel */}
                            <HeroContentCurationCard
                                setHeroBannerValidation={(
                                    value: boolean,
                                    banners: [any]
                                ) => {
                                    setIsHeroBannerValid(value);
                                    setHeroBannersInDraft(banners);
                                }}
                                heroBannerStatus={(value: boolean) =>
                                    setShowHeroBanners(value)
                                }
                                ref={heroCarousalRef}
                                allowEdit={allowEdit}
                                videoAPILoader={videoAPILoader}
                                handleBanners={setHeroBanners}
                                videos={videos}
                                playlist={playlist}
                                className={"curation-card-nodrag"}
                                onClickEdit={() =>
                                    handleEditRail(rail, index, RAIL_TYPE.hero)
                                }
                                onClickDelete={() =>
                                    handleDeleteRail(index, RAIL_TYPE.hero)
                                }
                                data={rail}
                                index={index}
                                onClickAdd={() => handleOpenPopup(index)}
                            />
                        </div>
                    );
                })}
                {/* Continue watching rails */}
                {cwRail.map((rail: any, index: number) => {
                    return (
                        <div key={index} className="d-flex j-center mt-1">
                            {/* hero carousel */}
                            <ContentCurationCard
                                handleUnlock={() => setCwUnlockPopup(true)}
                                allowEdit={allowEdit}
                                className={"curation-card-nodrag"}
                                onClickEdit={() =>
                                    handleEditRail(
                                        rail,
                                        index,
                                        RAIL_TYPE.continue_watching
                                    )
                                }
                                onClickDelete={() =>
                                    handleDeleteRail(
                                        index,
                                        RAIL_TYPE.continue_watching
                                    )
                                }
                                data={rail}
                                index={index}
                                onClickAdd={() => handleOpenPopup(index)}
                            />
                        </div>
                    );
                })}
                {/* rest of the rails */}
                <DragDropContext
                    onDragEnd={onDragEnd}
                    onBeforeCapture={onBeforeCapture}
                >
                    <Droppable
                        isDropDisabled={!allowEdit}
                        droppableId="droppable-parent-curation"
                        type={`parent`}
                        key={`droppable-parent-curation`}
                    >
                        {(provided, snapshot) => (
                            <div
                                className="d-flex j-center mt-1 flex-column"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                {otherRails.map((item: any, index: number) => (
                                    <Draggable
                                        isDragDisabled={!allowEdit}
                                        key={`index-${index}`}
                                        draggableId={`rail-${index}`}
                                        index={index}
                                    >
                                        {(provided: any, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps
                                                        .style
                                                )}
                                                className="d-flex float-center"
                                            >
                                                {item?.template ==
                                                    CW_CAROUSEL &&
                                                    item?.unlock && (
                                                        <ContentCurationCard
                                                            dragHandleProps={{
                                                                ...provided.dragHandleProps,
                                                            }}
                                                            allowEdit={
                                                                allowEdit
                                                            }
                                                            className={
                                                                "curation-card"
                                                            }
                                                            onClickEdit={() =>
                                                                handleEditRail(
                                                                    item,
                                                                    index,
                                                                    RAIL_TYPE.continue_watching
                                                                )
                                                            }
                                                            onClickDelete={() =>
                                                                handleDeleteRail(
                                                                    index,
                                                                    RAIL_TYPE.continue_watching,
                                                                    true
                                                                )
                                                            }
                                                            data={item}
                                                            index={index}
                                                            onClickAdd={() =>
                                                                handleOpenPopup(
                                                                    index
                                                                )
                                                            }
                                                        />
                                                    )}
                                                {item?.template == MY_LIST && (
                                                    <ContentCurationCard
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        allowEdit={allowEdit}
                                                        className={
                                                            "curation-card"
                                                        }
                                                        onClickEdit={() =>
                                                            handleEditRail(
                                                                item,
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                index
                                                            )
                                                        }
                                                    />
                                                )}

                                                {item?.template == GENRE && (
                                                    <GenreContentCurationCard
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        handleRail={(
                                                            value: any
                                                        ) =>
                                                            setRailData(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleGenreTitle={(
                                                            value: any
                                                        ) =>
                                                            saveRailTitle(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleGenres={(
                                                            value: any
                                                        ) =>
                                                            updateValue(
                                                                value,
                                                                index,
                                                                "genres"
                                                            )
                                                        }
                                                        genreMasterList={
                                                            genreMasterList
                                                        }
                                                        className={
                                                            "curation-card-nodrag"
                                                        }
                                                        onClickEdit={() =>
                                                            handleEditRail(
                                                                item,
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                                {(item?.template ==
                                                    POSTER_HORIZONTAL ||
                                                    item?.template ==
                                                        POSTER_VERTICAL ||
                                                    item?.template ==
                                                        POPULAR_SEARCHES ||
                                                    item?.template ==
                                                        NO_RESULTS) && (
                                                    <ContentCurationCard
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        hideAddButton={
                                                            hideAddButton
                                                        }
                                                        onClickEdit={() =>
                                                            handleEditRail(
                                                                item,
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        className={
                                                            "curation-card"
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                                {item?.template == THEMATIC && (
                                                    <ThematicContentCurationCard
                                                        handleFormChange={(
                                                            e: any
                                                        ) =>
                                                            onThematicFormChange(
                                                                e,
                                                                index
                                                            )
                                                        }
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        playlist={playlist}
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        handleThematicTitle={(
                                                            value: any
                                                        ) =>
                                                            saveRailTitle(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleRail={(
                                                            value: any
                                                        ) =>
                                                            setRailData(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        className={
                                                            "curation-card-nodrag"
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                                {item?.template ==
                                                    SINGULAR_PROMO && (
                                                    <SingularPromoContentCurationCard
                                                        handleFormChange={(
                                                            e: any
                                                        ) =>
                                                            onThematicFormChange(
                                                                e,
                                                                index
                                                            )
                                                        }
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        videos={videos}
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        handleRailTitle={(
                                                            value: any
                                                        ) =>
                                                            saveRailTitle(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleRail={(
                                                            value: any
                                                        ) =>
                                                            setRailData(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        className={
                                                            "curation-card-nodrag"
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                                {item?.template ==
                                                    EPISODIC_RAIL && (
                                                    <EpisodicContentCurationCard
                                                        handleFormChange={(
                                                            e: any
                                                        ) =>
                                                            onThematicFormChange(
                                                                e,
                                                                index
                                                            )
                                                        }
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        playlist={playlist}
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        handleRailTitle={(
                                                            value: any
                                                        ) =>
                                                            saveRailTitle(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleRail={(
                                                            value: any
                                                        ) =>
                                                            setRailData(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        className={
                                                            "curation-card-nodrag"
                                                        }
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                                {item?.template ==
                                                    COLLECTIONS && (
                                                    <CollectionsContentCurationCard
                                                        ref={
                                                            railRefs.current[
                                                                index
                                                            ]
                                                        }
                                                        allowEdit={allowEdit}
                                                        dragHandleProps={{
                                                            ...provided.dragHandleProps,
                                                        }}
                                                        handleRail={(
                                                            value: any
                                                        ) =>
                                                            setRailData(
                                                                value,
                                                                index
                                                            )
                                                        }
                                                        handleCollections={(
                                                            value: any
                                                        ) =>
                                                            updateValue(
                                                                value,
                                                                index,
                                                                "collections"
                                                            )
                                                        }
                                                        playlist={playlist}
                                                        onClickDelete={() =>
                                                            handleDeleteRail(
                                                                index,
                                                                RAIL_TYPE.others
                                                            )
                                                        }
                                                        data={item}
                                                        index={index}
                                                        onClickAdd={() =>
                                                            handleOpenPopup(
                                                                heroRail.length +
                                                                    cwRail.length +
                                                                    index
                                                            )
                                                        }
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>

            <GeneralModalV1
                title="Confirm Rail Unlock"
                isOpen={cwUnlockPopup}
                handleClose={() => setCwUnlockPopup(false)}
                handleConfirm={handleCWUnlock}
            >
                <p>
                    {" "}
                    Unlocking this rail will allow it to be rearranged. Are you
                    sure you want to unlock the rail??
                </p>
            </GeneralModalV1>

            {openCreatePopup && (
                <CreatePagePopup
                    template={formValues?.template}
                    playlist={playlist}
                    selectedRail={selectedIndex}
                    railList={railList}
                    show={openCreatePopup}
                    handleCloseCB={handleClosePopup}
                    handleAddRail={handleAddRail}
                    handleEditRail={handleEditSubmission}
                />
            )}
        </div>
    );
};

export default ContentCurationList;
